import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PermissionModule } from './core/permission/permission.module';

@NgModule({
  imports: [CommonModule, PermissionModule],
  declarations: []
})
export class DomainModule {}
